import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import api from '../../utils/axiosInstance';
import AdminSideMenu from '../../components/AdminSideMenu';
import Select from 'react-select';

const DriverCreate = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        experience: '',
        route: [],
        job: '',
        trailer: [],
        cdl: '',
        endorsements: [],
        password: '',
        confirmPassword: '',
        terms: true,
    });
    const [file, setFile] = useState(null);
    const [uploadMessage, setUploadMessage] = useState('');
    const [rejectedDrivers, setRejectedDrivers] = useState([]);
    // // NEW TAG → selected package
    // const [selectedPackage, setSelectedPackage] = useState(null);
    // const [packageOptions, setPackageOptions] = useState([]);

    const trailerOptions = [
        { value: 'Van', label: 'Van' },
        { value: 'Flatbed', label: 'Flatbed' },
        { value: 'Reefer', label: 'Reefer' },
        { value: 'Tanker', label: 'Tanker' },
        { value: 'Other', label: 'Others' },
    ];

    const routeOptions = [
        { value: 'OTR', label: 'Over the Road' },
        { value: 'Regional', label: 'Regional' },
        { value: 'Local', label: 'Local' },
        { value: 'All', label: 'All Routes' },
    ];

    const endorsementOptions = [
        { value: 'Hazmat', label: 'Hazmat' },
        { value: 'Double', label: 'Doubles/Triples' },
        { value: 'Tank', label: 'Tank' },
        { value: 'Hazardous', label: 'Hazardous Tanker' },
        { value: 'Passenger', label: 'Passenger' },
        { value: 'None', label: 'None of these' },
    ];

    const STATES = [
        { code: 'AL', name: 'Alabama' },
        { code: 'AK', name: 'Alaska' },
        { code: 'AZ', name: 'Arizona' },
        { code: 'AR', name: 'Arkansas' },
        { code: 'CA', name: 'California' },
        { code: 'CO', name: 'Colorado' },
        { code: 'CT', name: 'Connecticut' },
        { code: 'DE', name: 'Delaware' },
        { code: 'FL', name: 'Florida' },
        { code: 'GA', name: 'Georgia' },
        { code: 'HI', name: 'Hawaii' },
        { code: 'ID', name: 'Idaho' },
        { code: 'IL', name: 'Illinois' },
        { code: 'IN', name: 'Indiana' },
        { code: 'IA', name: 'Iowa' },
        { code: 'KS', name: 'Kansas' },
        { code: 'KY', name: 'Kentucky' },
        { code: 'LA', name: 'Louisiana' },
        { code: 'ME', name: 'Maine' },
        { code: 'MD', name: 'Maryland' },
        { code: 'MA', name: 'Massachusetts' },
        { code: 'MI', name: 'Michigan' },
        { code: 'MN', name: 'Minnesota' },
        { code: 'MS', name: 'Mississippi' },
        { code: 'MO', name: 'Missouri' },
        { code: 'MT', name: 'Montana' },
        { code: 'NE', name: 'Nebraska' },
        { code: 'NV', name: 'Nevada' },
        { code: 'NH', name: 'New Hampshire' },
        { code: 'NJ', name: 'New Jersey' },
        { code: 'NM', name: 'New Mexico' },
        { code: 'NY', name: 'New York' },
        { code: 'NC', name: 'North Carolina' },
        { code: 'ND', name: 'North Dakota' },
        { code: 'OH', name: 'Ohio' },
        { code: 'OK', name: 'Oklahoma' },
        { code: 'OR', name: 'Oregon' },
        { code: 'PA', name: 'Pennsylvania' },
        { code: 'RI', name: 'Rhode Island' },
        { code: 'SC', name: 'South Carolina' },
        { code: 'SD', name: 'South Dakota' },
        { code: 'TN', name: 'Tennessee' },
        { code: 'TX', name: 'Texas' },
        { code: 'UT', name: 'Utah' },
        { code: 'VT', name: 'Vermont' },
        { code: 'VA', name: 'Virginia' },
        { code: 'WA', name: 'Washington' },
        { code: 'WV', name: 'West Virginia' },
        { code: 'WI', name: 'Wisconsin' },
        { code: 'WY', name: 'Wyoming' },
    ];

    // useEffect(() => {
    //     const fetchPackages = async () => {
    //         try {
    //             const res = await api.get('/packages/active');
    //             setPackageOptions(
    //                 res.data.map((pkg) => ({
    //                     value: pkg._id,
    //                     label: `${pkg.name} (${pkg.noOfDrivers} drivers)`,
    //                 })),
    //             );
    //         } catch (error) {
    //             console.error('Failed to load packages');
    //         }
    //     };

    //     fetchPackages();
    // }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleFileUpload = async (assignToCarriers = false) => {
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);

                // Send to backend
                const response = await api.post('/drivers/bulk', {
                    drivers: jsonData,
                    assignToCarriers,
                });

                const { totalProcessed, insertedCount, failedCount, failedRows } = response.data;

                setUploadMessage(
                    `Total: ${totalProcessed}, Successfully Added: ${insertedCount}, Rejected: ${failedCount}`,
                );

                // Save rejected data for later download
                if (failedRows && failedRows.length > 0) {
                    setRejectedDrivers(failedRows);
                } else {
                    setRejectedDrivers([]);
                }
            } catch (err) {
                setUploadMessage('Upload failed: ' + (err.response?.data?.message || err.message));
            }
        };
        reader.readAsArrayBuffer(file);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            alert('Passwords do not match');
            return;
        }
        try {
            await api.post('/drivers', formData);
            alert('Driver created successfully');
            window.location.reload();
        } catch (err) {
            const errorMsg = err.response?.data?.message || 'Failed to create driver';
            alert(errorMsg);
        }
    };

    const handlePhoneChange = (e) => {
        let raw = e.target.value.replace(/\D/g, '').slice(0, 10); // Only digits, max 10
        let formatted = raw;
        if (raw.length > 6) {
            formatted = `(${raw.slice(0, 3)}) ${raw.slice(3, 6)}-${raw.slice(6, 10)}`;
        } else if (raw.length > 3) {
            formatted = `(${raw.slice(0, 3)}) ${raw.slice(3)}`;
        } else if (raw.length > 0) {
            formatted = `(${raw}`;
        }
        setFormData({ ...formData, phone: formatted });
    };

    const downloadRejectedDrivers = () => {
        if (rejectedDrivers.length === 0) return;

        const formattedData = rejectedDrivers.map(({ row, error, data }) => ({
            Row: row,
            ...data,
            Error: error,
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Rejected Drivers');

        XLSX.writeFile(workbook, 'Rejected_Drivers.xlsx');
    };

    return (
        <div className='flex'>
            <AdminSideMenu />
            <div className='md:ml-64 min-h-screen w-full bg-gray-50 p-4 md:p-8'>
                <h1 className='text-3xl font-bold mb-6'>Add Driver</h1>

                {/* File Upload Section */}
                <div className='bg-white p-6 rounded-xl shadow mb-8'>
                    <h2 className='text-xl font-semibold mb-4'>Bulk Upload via CSV/Excel</h2>
                    <span className='block text-sm text-blue-700 font-semibold mb-2'>
                        Only accept this format for driver upload
                    </span>
                    <div className='flex items-center gap-2'>
                        <a
                            href='${process.env.REACT_APP_IMAGE_BASE_URL}/templates/DriverUploadFormat.xlsx'
                            download='DriverUploadFormat.csv'
                            className='text-blue-600 underline font-semibold hover:text-black transition-colors'
                        >
                            Driver Upload Format
                        </a>

                        <input
                            type='file'
                            accept='.xlsx,.xls,.csv'
                            onChange={handleFileChange}
                            className='border border-gray-300 rounded px-4 py-2 ml-10'
                        />
                        <div className='flex items-center gap-4  flex-wrap'>
                            <button
                                onClick={() => handleFileUpload(true)}
                                className='bg-blue-600 text-white px-6 py-2 rounded hover:bg-black'
                            >
                                Upload & Assign to Carriers
                            </button>
                            <button
                                onClick={() => handleFileUpload(false)}
                                className='bg-gray text-white px-6 py-2 rounded hover:bg-blue-700 ml-10'
                            >
                                Upload directly to Database
                            </button>
                        </div>

                        {/* Show rejected button clearly below */}
                        {rejectedDrivers.length > 0 && (
                            <div className='mt-4'>
                                <button
                                    onClick={downloadRejectedDrivers}
                                    className='bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700'
                                >
                                    Download Rejected Drivers ({rejectedDrivers.length})
                                </button>
                            </div>
                        )}
                    </div>
                    {uploadMessage && <p className='mt-2 text-sm text-gray-600'>{uploadMessage}</p>}
                </div>

                {/* Manual Form Section */}
                <form onSubmit={handleSubmit} className='bg-white p-6 rounded-xl shadow space-y-6'>
                    {/* 1st row: Name & Experience */}
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                        <div>
                            <label className='block font-medium'>Name *</label>
                            <input
                                name='name'
                                type='text'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div>
                            <label className='block font-medium'>Experience *</label>
                            <select
                                name='experience'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.experience}
                                onChange={handleChange}
                                required
                            >
                                <option value=''>Select experience</option>
                                <option value='none'>None</option>
                                <option value='6 months'>6 months</option>
                                <option value='1 year'>1 Year</option>
                                <option value='2 year'>2 Year</option>
                                <option value='3+'>3+ Years</option>
                            </select>
                        </div>
                    </div>

                    {/* 2nd row: Route & Job */}
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                        <div>
                            <label className='block font-medium'>Route Type *</label>
                            <Select
                                isMulti
                                name='route'
                                required
                                options={routeOptions}
                                value={routeOptions.filter((opt) => formData.route.includes(opt.value))}
                                onChange={(selected) =>
                                    setFormData({ ...formData, route: selected.map((s) => s.value) })
                                }
                            />
                        </div>
                        <div>
                            <label className='block font-medium'>Job Type *</label>
                            <select
                                name='job'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.job}
                                required
                                onChange={handleChange}
                            >
                                <option value=''>Select Job Type</option>
                                <option value='Company Driver'>Company Driver</option>
                                <option value='Owner Operator'>Owner Operator</option>
                                <option value='Training'>Driver Training</option>
                                <option value='Lease'>Lease Purchase</option>
                            </select>
                        </div>
                    </div>

                    {/* 3rd row: Trailer & CDL */}
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                        <div>
                            <label className='block font-medium'>Trailer Type *</label>
                            <Select
                                isMulti
                                name='trailer'
                                required
                                options={trailerOptions}
                                value={trailerOptions.filter((opt) => formData.trailer.includes(opt.value))}
                                onChange={(selected) =>
                                    setFormData({ ...formData, trailer: selected.map((s) => s.value) })
                                }
                            />
                        </div>
                        <div>
                            <label className='block font-medium'>CDL Type *</label>
                            <select
                                name='cdl'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.cdl}
                                onChange={handleChange}
                                required
                            >
                                <option value=''>Select CDL</option>
                                <option value='Class A'>Class A</option>
                                <option value='Class B'>Class B</option>
                                <option value='Class C'>Class C</option>
                                <option value='No CDL'>I don't have a CDL</option>
                            </select>
                        </div>
                    </div>

                    {/* 4th row: Endorsements & Phone */}
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                        <div>
                            <label className='block font-medium'>Endorsements *</label>
                            <Select
                                isMulti
                                name='endorsements'
                                options={endorsementOptions}
                                required
                                value={endorsementOptions.filter((opt) => formData.endorsements.includes(opt.value))}
                                onChange={(selected) =>
                                    setFormData({ ...formData, endorsements: selected.map((s) => s.value) })
                                }
                            />
                        </div>
                        <div>
                            <label className='block font-medium'>Phone *</label>
                            <input
                                name='phone'
                                type='tel'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.phone}
                                onChange={handlePhoneChange}
                                required
                                maxLength={14}
                                placeholder='(123) 456-7890'
                                autoComplete='off'
                            />
                        </div>
                    </div>

                    {/* 5th row: Address (full width) */}
                    <div>
                        <label className='block font-medium'>Address *</label>
                        <input
                            name='address'
                            type='text'
                            required
                            className='w-full border border-gray-300 rounded px-4 py-2'
                            value={formData.address}
                            onChange={handleChange}
                        />
                    </div>

                    {/* 6th row: City & State */}
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                        <div>
                            <label className='block font-medium'>City *</label>
                            <input
                                name='city'
                                type='text'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.city}
                                required
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <label className='block font-medium'>State *</label>
                            <select
                                name='state'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.state}
                                required
                                onChange={handleChange}
                            >
                                <option value=''>Select State</option>
                                {STATES.map((state) => (
                                    <option key={state.code} value={state.code}>
                                        {state.name} ({state.code})
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* 7th row: ZIP & Email */}
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                        <div>
                            <label className='block font-medium'>ZIP *</label>
                            <input
                                name='zip'
                                type='text'
                                required
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.zip}
                                onChange={handleChange}
                            />
                        </div>
                        <div>
                            <label className='block font-medium'>Email *</label>
                            <input
                                name='email'
                                type='email'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* 8th row: Password & Confirm Password */}
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                        <div>
                            <label className='block font-medium'>Password *</label>
                            <input
                                name='password'
                                type='password'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div>
                            <label className='block font-medium'>Confirm Password *</label>
                            <input
                                name='confirmPassword'
                                type='password'
                                className='w-full border border-gray-300 rounded px-4 py-2'
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <button
                        type='submit'
                        className='bg-blue-600 text-white px-8 py-3 rounded font-semibold hover:bg-blue-700'
                    >
                        Create Driver
                    </button>
                </form>
            </div>
        </div>
    );
};

export default DriverCreate;
